import { render, staticRenderFns } from "./PartDetails.vue?vue&type=template&id=59b4768c&scoped=true&"
import script from "./PartDetails.vue?vue&type=script&lang=js&"
export * from "./PartDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartDetails.vue?vue&type=style&index=0&id=59b4768c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4768c",
  null
  
)

export default component.exports